<template lang="pug">
  div
    v-row(v-if="['GA','RM'].includes(selectedUser && selectedUser.role)" no-gutters)
      v-toolbar(color='primary' dense dark extended extension-height='25px' fixed)
        v-btn(icon)
          v-icon(@click="vibrate();myRestaurants.length ? $router.push('/home'):$router.push('/login')") mdi-arrow-left
        v-toolbar-title.ma-0 Admin
        template(v-slot:extension)
          v-tabs(v-model='tab' background-color='primary' height='25px')
            v-tabs-slider(color='yellow')
            v-tab.pl-2.pr-2 Group
            v-tab.pl-2.pr-2(:disabled="!['GA'].includes(selectedUser && selectedUser.role) && !(selectedGroup.notes && selectedGroup.notes.includes('$test'))") Users
            v-tab.pl-2.pr-2 Products
    v-row(no-gutters)
      v-col(cols='12' sm='6' md='4' lg='3' xl='2')
        v-alert(v-model='showAlert' dismissible type='error') {{alertMessage}}
        v-card(v-if='tab==0')
          v-card-text.pa-2
            v-treeview.grey.lighten-5(dense :transition='true' :open.sync='open' :items='items' :load-children='fetchChildren' item-text="''")
              template(v-slot:prepend='{ item }')
                .v-treeview-node__label(style='float:left; width:200px' v-html='item.name')
              template(v-slot:append='{ item }')
                div
                  v-icon(v-if="['GA'].includes(selectedUser && selectedUser.role) && !['Sections','Counters'].includes(item.type)" @click='vibrate();editItem(item)' :color="item.model.status?'':'#C8C8C8'") mdi-pencil
                  v-icon(v-if="['RM'].includes(selectedUser && selectedUser.role) && !['Group','Sections','Counters'].includes(item.type)" @click='vibrate();editItem(item)' :color="item.model.status?'':'#C8C8C8'") mdi-pencil
                  v-icon(v-if="(['GA'].includes(selectedUser && selectedUser.role) && item.type=='Group') \
                  || (['GA','RM'].includes(selectedUser && selectedUser.role) && ['Sections','Counters'].includes(item.type))" @click='vibrate();addItemUnder(item)') mdi-plus
        v-card(v-if='tab==1')
          v-card-title.pa-0(v-if='Number(this.myFeatures.eligibleCounts.U) > 1')
            v-text-field.pl-4(v-model='search' append-icon='mdi-magnify' label='Search' single-line clearable hide-details)
            v-spacer
            v-btn(fab small color='grey' @click="vibrate();addItemUnder({type:'Users'})")
              v-icon mdi-plus
            v-spacer
          v-card-text.pa-0
            v-list.pa-0
              v-list-item(v-for='user in filteredUsers' :key='user.id')
                v-list-item-avatar
                  img(:src="user.imageUrl || '/images/maleface.jpg'")
                v-list-item-content  
                    v-list-item-title(v-if='selectedUser.id==user.id')
                      strong {{user.fullName}}
                    v-list-item-title(v-else @click="selectedGroup.notes && selectedGroup.notes.includes('$test')?selectUser(user):''") {{user.fullName}}
                    v-list-item-subtitle(v-text="(user.mobileNumber||'No Mobile') + ', Roles:' + user.roles.join(',')")
                v-list-item-action
                  v-btn(icon @click="vibrate();editItem({type:'User', model:user})")
                    v-icon(:color="user.status?'':'#C8C8C8'") mdi-pencil
        v-card(v-if='tab==2')
          v-card-title.pa-0
            //
              <v-btn @click="vibrate();alert('TODO')">Export CSV</v-btn>
              <v-btn @click="vibrate();alert('TODO')">Import CSV</v-btn>
            v-text-field.pl-4(v-model='search' append-icon='mdi-magnify' label='Search' single-line clearable hide-details)
            v-spacer
            v-btn(v-if="['GA'].includes(selectedUser && selectedUser.role)" fab small color='grey' @click="vibrate();addItemUnder({type:'Products'})")
              v-icon mdi-plus
            v-spacer
          v-card-text.pa-0
            v-list.pa-0
              v-list-item(v-for='product in filteredProducts' :key='product.id')
                v-list-item-avatar(tile)
                  img(:src="product.imageUrl || '/images/product.png'")
                v-list-item-content
                  v-list-item-title(v-text="product.name + '('+product.code+')'")
                  v-list-item-subtitle(v-text="'Tags: ' + product.tags.join(',')")
                v-list-item-action
                  v-btn(icon @click="vibrate();editItem({type:'Product', model:product})")
                    v-icon(:color="product.status?'':'#C8C8C8'") mdi-pencil
        group-dialog(v-if='mode.groupDialog' :editedItem='editedItem' :mode='mode' v-on:save='save($event)')
        restaurant-dialog(v-if='mode.restaurantDialog' :editedItem='editedItem' :mode='mode' v-on:save='save($event)' v-on:delete='deleteItem($event)' v-on:refresh="refreshRestaurant(myRestaurants,$event)")
        section-dialog(v-if='mode.sectionDialog' :editedItem='editedItem' :mode='mode' v-on:save='save($event)' v-on:delete='deleteItem($event)')
        counter-dialog(v-if='mode.counterDialog' :editedItem='editedItem' :mode='mode' v-on:save='save($event)' v-on:delete='deleteItem($event)')
        user-dialog(v-if='mode.userDialog' :editedItem='editedItem' :mode='mode' v-on:save='save($event)' v-on:delete='deleteItem($event)')
        product-dialog(v-if='mode.productDialog' :editedItem='editedItem' :mode='mode' v-on:save='save($event)' v-on:delete='deleteItem($event)')

</template>

<script>
import GroupDialog from "../components/dialogs/Group.vue";
import RestaurantDialog from "../components/dialogs/Restaurant.vue";
import SectionDialog from "../components/dialogs/Section.vue";
import CounterDialog from "../components/dialogs/Counter.vue";
import UserDialog from "../components/dialogs/User.vue";
import ProductDialog from "../components/dialogs/Product.vue";
import { storeMixin } from "../mixins/storeMixin.js";
import { scaffolderMixin } from "../mixins/scaffolderMixin.js";

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default {
  name: "admin",
  mixins: [storeMixin, scaffolderMixin],
  components: {
    GroupDialog,
    RestaurantDialog,
    SectionDialog,
    CounterDialog,
    UserDialog,
    ProductDialog,
  },
  async beforeMount() {
    this.myRestaurants = await this.allowedRestaurants;
  },
  data() {
    return {
      myRestaurants: [],
      mode: {
        groupDialog: false,
        restaurantDialog: false,
        sectionDialog: false,
        counterDialog: false,
        userDialog: false,
        productDialog: false,
      },
      opened: [],
      active: [],
      tabbed: null,
      search: "",
      userHeaders: [
        { text: "Full Name", value: "fullName", width: "22" },
        { text: "Mobile Number", value: "mobileNumber", width: "11" },
        { text: "Action", value: "action", width: "22" },
      ],
      editedItem: {},
      showAlert: false,
      alertMessage: "",
    };
  },
  computed: {
    items() {
      return this.selectedGroup
        ? [
            {
              id: "G~" + this.selectedGroup.id,
              name: "Group:<br>" + this.selectedGroup.name,
              type: "Group",
              model: this.selectedGroup,
              children: this.myRestaurants.map((r) => {
                return {
                  id: "R~" + r.id,
                  type: "Restaurant",
                  name: r.code + " : " + r.name,
                  model: r,
                  children: [
                    {
                      id: "S~" + r.id,
                      name: "Sections",
                      type: "Sections",
                      _restaurantId: r.id,
                      children: this.sections.map((s) => {
                        return {
                          id: "s~" + s.id,
                          type: "Section",
                          name: s.code + " : " + s.name,
                          model: s,
                        };
                      }),
                    },
                    {
                      id: "C~" + r.id,
                      name: "Counters",
                      type: "Counters",
                      _restaurantId: r.id,
                      children: this.counters.map((c) => {
                        return {
                          id: "c~" + c.id,
                          type: "Counter",
                          name: c.code + " : " + c.name,
                          model: c,
                        };
                      }),
                    },
                  ],
                };
              }),
            },
          ]
        : [];
    },
    open: {
      get: function () {
        return this.opened;
      },
      set: function (nval) {
        let r2cIndex = -1;
        const expanded = nval.length > this.opened.length;

        if (expanded) {
          let newRs = nval.filter((i) => i.startsWith("R~"));
          let openedRs = this.opened.filter((i) => i.startsWith("R~"));
          if (newRs.length == 2 && openedRs.length == 1) {
            let r2c = openedRs[0] === newRs[0] ? newRs[0] : newRs[1];
            r2cIndex = nval.findIndex((n) => n == r2c);
            if (r2cIndex > -1) {
              nval.splice(r2cIndex, 1);
              let selectR = nval.find((n) => n.startsWith("R~"));
              let r2o = this.items[0].children.find((child) => {
                return child.id == selectR;
              });
              this.selectRestaurant(r2o.model);
              this.bindSections();
              this.bindCounters();
            }
          }
          if (newRs.length == 1 && openedRs.length == 0) {
            //first time open
            let r2o = this.items[0].children.find((child) => {
              return child.id == newRs[0];
            });
            this.selectRestaurant(r2o.model);
            this.bindSections();
            this.bindCounters();
          }
        }
        this.opened = nval;
      },
    },
    tab: {
      get: function () {
        return this.tabbed;
      },
      set: function (nval) {
        if (nval == 1) {
          this.bindUsers();
        }
        if (nval == 2) {
          this.bindGroupProducts();
        }
        this.tabbed = nval;
      },
    },
    filteredUsers() {
      let tempUsers = this.users.filter((user) => {
        if (this.search) {
          return (
            String(user.fullName)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1 ||
            String(user.mobileNumber)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1 ||
            String(user.code).toLowerCase().indexOf(this.search.toLowerCase()) >
              -1 ||
            String(user.roles.join(","))
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1
          );
        }
        return true;
      });
      return tempUsers;
    },
    filteredProducts() {
      let tempProducts = this.groupProducts.filter((product) => {
        if (this.search) {
          return (
            String(product.name)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1 ||
            String(product.code)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1 ||
            String(product.tags.join(","))
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1
          );
        }
        return true;
      });
      tempProducts.sort((p1, p2) => {
        let retVal = 0;
        if (p1.code) {
          if (p1.code > p2.code) retVal = -1;
          if (p1.code < p2.code) retVal = 1;
        }
        return retVal;
      });
      return tempProducts;
    },
  },
  methods: {
    async fetchChildren(item) {
      if (item.type == "Group") {
        this.bindRestaurants();
        await pause(1500);
      } else if (item.type == "Restaurant") {
        this.selectRestaurant(item.model);
        await pause(1500);
      } else if (item.type == "Sections") {
        this.bindSections();
        await pause(1500);
      } else if (item.type == "Counters") {
        this.bindCounters();
        await pause(1500);
      }
    },
    async editItem(item) {
      // this.editedItem = Object.assign({}, item.model);
      this.editedItem = JSON.parse(JSON.stringify(item.model));
      if (!this.users.length) {
        this.bindUsers();
        await pause(1000);
      }
      switch (item.type) {
        case "Group":
          this.mode.groupDialog = true;
          break;
        case "Restaurant":
          this.mode.restaurantDialog = true;
          break;
        case "Section":
          this.mode.sectionDialog = true;
          break;
        case "Counter":
          this.mode.counterDialog = true;
          break;
        case "User":
          this.mode.userDialog = true;
          break;
        case "Product":
          this.mode.productDialog = true;
          break;
        default:
          this.mode.groupDialog = false;
          this.mode.restaurantDialog = false;
          this.node.sectionDialog = false;
          this.mode.counterDialog = false;
          this.mode.userDialog = false;
          this.mode.productDialog = false;
          break;
      }
    },
    async addItemUnder(item) {
      switch (item.type) {
        case "Group":
          if (this.myRestaurants.length < this.myFeatures.eligibleCounts.R) {
            await this.createDefaultRestaurant(
              item.model.id,
              this.getNextCode("R")
            );
            this.myRestaurants = await this.allowedRestaurants; //Needs refresh
          } else {
            this.alertMessage = `Under your selected plan, more than ${this.myFeatures.eligibleCounts.R} restaurant(s) cannot be added. An upgrade would be required to increase the limit. Please refer to the product page for details.`;
            this.showAlert = true;
          }
          break;
        case "Sections":
          if (this.sections.length < this.myFeatures.eligibleCounts.S) {
            await this.createDefaultSection(
              this.selectedGroup.id,
              item._restaurantId,
              this.getNextCode("S")
            );
          } else {
            this.alertMessage = `Under your selected plan, more than ${this.myFeatures.eligibleCounts.S} section(s) cannot be added. An upgrade would be required to increase the limit. Please refer to the product page for details.`;
            this.showAlert = true;
          }
          break;
        case "Counters":
          if (this.counters.length < this.myFeatures.eligibleCounts.C) {
            await this.createDefaultCounter(
              this.selectedGroup.id,
              item._restaurantId,
              this.getNextCode("C")
            );
          } else {
            this.alertMessage = `Under your selected plan, more than ${this.myFeatures.eligibleCounts.C} counter(s) cannot be added. An upgrade would be required to increase the limit. Please refer to the product page for details.`;
            this.showAlert = true;
          }
          break;
        case "Users":
          if (this.myFeatures.eligibleCounts.U >= this.users.length) {
            let user = {
              _groupKey: this.selectedGroup.id,
              code: this.getNextCode("U"),
              fullName: "New User" + (this.users.length + 1),
              role: "",
              roles: [],
              mobileNumber: "0000000000",
              email: "a@a.com",
              hourlyRate: 0,
              notes: "",
              status: 0,
            };
            const payLoad = {
              collectionName: "users",
              doc: user,
            };
            this.createDoc(payLoad);
          } else {
            this.alertMessage = `Under your selected plan, more than ${this.myFeatures.eligibleCounts.U} user(s) cannot be added. An upgrade would be required to increase the limit. Please refer to the product page for details.`;
            this.showAlert = true;
          }
          break;
        case "Products":
          if (this.myFeatures.eligibleCounts.P >= this.groupProducts.length) {
            await this.createDefaultProduct(
              this.selectedGroup.id,
              this.getNextCode("P")
            );
          } else {
            this.alertMessage = `Under your selected plan, more than ${this.myFeatures.eligibleCounts.P} product(s) cannot be added. An upgrade would be required to increase the limit. Please refer to the product page for details.`;
            this.showAlert = true;
          }
          break;
        default:
          this.mode.groupDialog = false;
          this.mode.restaurantDialog = false;
          this.node.sectionDialog = false;
          this.mode.counterDialog = false;
          this.mode.userDialog = false;
          this.mode.productDialog = false;
          break;
      }
      //alert("Add Item under : " + item.type + " : " + item.name);
    },
    save(payLoad) {
      if (payLoad.doc.id) {
        delete payLoad.doc.id;
        this.updateDoc(payLoad);
      } else {
        this.createDoc(payLoad);
      }
    },
    refreshRestaurant(myRestaurants, restaurant) {
      const idx = myRestaurants.findIndex((r) => r.id == restaurant.id);
      if (idx != -1) {
        myRestaurants[idx] = restaurant;
      }
    },
    deleteItem(payLoad) {
      this.deleteDoc(payLoad);
    },
    getNextCode(codeType) {
      let code = "";
      let lastIndex = this.myFeatures.eligibleCounts[codeType] - 1;
      switch (codeType) {
        case "R":
          code = (this.myRestaurants.length + 1).toString().padStart(3, "0");
          break;
        case "S":
          if (lastIndex && lastIndex === this.sections.length) {
            code = "Z";
          } else {
            code = this.sections.length + 1;
          }
          break;
        case "C":
          if (lastIndex && lastIndex === this.counters.length) {
            code = "Z";
          } else {
            code = this.counters.length + 1;
          }
          break;
        case "U":
          if (lastIndex && lastIndex === this.users.length) {
            code = "Z";
          } else {
            code = this.users.length + 1;
          }
          code = code.toString().padStart(3, "0");
          break;
        case "P":
          if (lastIndex && lastIndex === this.groupProducts.length) {
            code = "Z";
          } else {
            code = this.groupProducts.length + 1;
          }
          code = code.toString().padStart(3, "0");
          break;
        default:
          break;
      }
      return codeType + code;
    },
  },
};
</script>
<style>
.v-tab {
  text-transform: none;
}
</style>